import './customSpecialtyDrawer.scss';

import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Window } from '../overlays/window';
import { WindowHeader } from '../overlays/windowHeader';
import { CustomSpecialtyDrawerState } from './customSpecialtyDrawerState';

type Props = {
  model: CustomSpecialtyDrawerState;
};

export const CustomSpecialtyDrawer = observer(({ model }: Props) => {
  useEffect(() => {
    model.window.listen((msg) => {
      if (msg.type === 'close' || msg.type === 'outsideClick') {
        model.close();
      }
    });
  }, [model]);

  return (
    <Window
      model={model.window}
      visible={model.window.isVisible}
      className="custom-specialty-drawer"
      closeOnEscKey={true}>

      <WindowHeader
        model={model.window}
        title="Custom Specialty Details"
      />

      <div className="drawer-body">
        {model.isLoading && (
          <div className="drawer-loading">Loading...</div>
        )}

        {model.error && (
          <div className="drawer-error">{model.error}</div>
        )}

        {model.specialty && (
          <>
            <div className="drawer-section">
              <h4 className="drawer-section-title">Name</h4>
              <p className="drawer-section-content">{model.specialty.name}</p>
            </div>

            {model.specialty.description && (
              <div className="drawer-section">
                <h4 className="drawer-section-title">Description</h4>
                <p className="drawer-section-content">{model.specialty.description}</p>
              </div>
            )}

            <div className="drawer-section">
              <h4 className="drawer-section-title">Status</h4>
              <span className={`drawer-status drawer-status-${model.specialty.status.toLowerCase()}`}>
                {model.specialty.status}
              </span>
            </div>

            {model.specialty.generatedPrompt && (
              <div className="drawer-section">
                <h4 className="drawer-section-title">Generated Prompt</h4>
                <div className="drawer-prompt-container">
                  <pre className="drawer-prompt-content">
                    {model.isPromptExpanded
                      ? model.specialty.generatedPrompt
                      : model.truncatedPrompt}
                  </pre>
                  {model.specialty.generatedPrompt.length > 300 && (
                    <button
                      className="drawer-prompt-toggle"
                      onClick={() => model.togglePromptExpanded()}>
                      {model.isPromptExpanded ? 'Show less' : 'Show full prompt'}
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Window>
  );
});
